export enum TipoInputTextEnum {
    Search = "search-input",
   
  }